import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { bootstrapApplication } from '@angular/platform-browser';
import { EnvironmentType } from '@models/env';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import './polyfills';
import { logClientError } from '@utils/server-log';

// Handle chunk loading errors (happens when new deploy invalidates old chunks)
const handleChunkError = () => {
  const reloadKey = 'chunk_error_reload';
  const lastReload = sessionStorage.getItem(reloadKey);
  const now = Date.now();

  // Prevent infinite reload loop - only reload once per 30 seconds
  if (!lastReload || now - parseInt(lastReload, 10) > 30000) {
    sessionStorage.setItem(reloadKey, now.toString());
    window.location.reload();
  }
};

const chunkFailedPattern =
  /Loading chunk [\d]+ failed|Failed to fetch dynamically imported module|ChunkLoadError/;

window.addEventListener('error', (event) => {
  if (chunkFailedPattern.test(event.message)) {
    handleChunkError();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason &&
    chunkFailedPattern.test(event.reason.message || event.reason)
  ) {
    handleChunkError();
  }
});

registerLocaleData(localePt);

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  logClientError('Falha ao iniciar aplicação', err),
);

export const endpointBaseGRPC =
  environment.env === EnvironmentType.development
    ? 'https://grpcweb.svm.development.supermup.com.br'
    : environment.env === EnvironmentType.homolog
      ? 'https://grpcweb.svm.homolog.supermup.com.br'
      : 'https://grpcweb.mare.svm.com.br';

export const endpointBase =
  environment.env === EnvironmentType.development
    ? ''
    : environment.env === EnvironmentType.homolog
      ? ''
      : '';

export const applicationClientId =
  environment.env === EnvironmentType.development
    ? ''
    : environment.env === EnvironmentType.homolog
      ? ''
      : '';
